import type { ILoginLocale } from '@/Pages/Onboard/Login/Locale/Login.locale';

const esES: ILoginLocale = {
  title: 'Iniciar sesión en {brand}',
  email: {
    label: 'Correo Electrónico',
    placeholder: 'ejemplo@correo.com',
    error: 'Por favor ingresa un correo electrónico válido',
  },
  password: {
    label: 'Contraseña',
    placeholder: 'Tu contraseña',
    error: 'La contraseña es obligatoria',
  },
  passcode: {
    label: 'Código de autenticación',
    placeholder: '000000',
  },
  twoFactor: {
    title: 'Autenticación de dos factores',
    subtitle: 'Ingresa el código de 6 dígitos de tu app autenticadora para {email}.',
  },
  button: {
    login: 'Iniciar Sesión',
    forgotPassword: '¿Olvidaste tu contraseña?',
    verify: 'Verificar',
    back: 'Volver',
  },
  terms: {
    message1: 'Al iniciar sesión, aceptas',
    message2: ' nuestra ',
    terms: 'Términos de Servicio',
    privacy: 'Política de Privacidad',
  },
  errors: {
    invalidCredentials: 'Correo electrónico o contraseña inválidos. Por favor, inténtalo de nuevo.',
    accountLocked: 'Tu cuenta ha sido bloqueada. Por favor, contacta con soporte.',
    accountDisabled: 'Tu cuenta ha sido desactivada. Por favor, contacta con soporte.',
    networkError: 'Error de red. Por favor, verifica tu conexión e inténtalo de nuevo.',
    twoFactorRequired: 'Autenticación de dos factores requerida.',
    requiredPasscode: 'Ingresa tu código de 6 dígitos de autenticación de dos factores.',
    invalidPasscode: 'Código de autenticación inválido. Inténtalo de nuevo.',
    blockedPassword: 'Cuenta bloqueada temporalmente. Restablece tu contraseña.',
    blockedTwoFactor: 'Demasiados intentos inválidos. Inténtalo de nuevo en {time}.',
    blockedTwoFactorToast: 'Demasiados intentos inválidos. Inténtalo de nuevo en unos minutos.',
    twoFactorBootstrapMissingToken:
      'Token de configuración 2FA ausente. Por favor, inicia sesión de nuevo.',
  },
  cookieConsent: {
    necessary: 'Cookies Estrictamente Necesarias',
    analytics: 'Cookies de Análisis',
    necessaryDescription:
      'Estas cookies son esenciales para que el sitio web funcione correctamente. Permiten funciones básicas como la navegación por páginas y el acceso a áreas seguras del sitio web. El sitio web no puede funcionar correctamente sin estas cookies.',
    analyticsDescription:
      'Estas cookies nos ayudan a entender cómo los visitantes interactúan con nuestro sitio web al recopilar y reportar información de forma anónima. Estos datos se utilizan para mejorar el rendimiento y la experiencia del usuario en nuestro sitio.',
  },
};
export { esES };
